import React, { useState, useEffect } from 'react';
import { Button, Input, Tooltip, } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { AbTestingFragmentOutcomeModel } from '../../../../../dto/admin-rule-models';

type AbTestingRandomChanceOutcomeProps = {
  actionValue: string;
  onChange: (newValue: string) => void;
};

const AbTestingRandomChanceOutcome = ({ actionValue, onChange }: AbTestingRandomChanceOutcomeProps) => {
  const [percentageValues, setPercentageValues] = useState<AbTestingFragmentOutcomeModel[]>([]);

  useEffect(() => {
    if (!actionValue) {
      setPercentageValues([{ feId: crypto.randomUUID(), percentage: 0, value: '' }]);
      return;
    }
    try {
      const existingPercentValue: AbTestingFragmentOutcomeModel[] = JSON.parse(actionValue);
      existingPercentValue?.forEach((item) => {
        item.feId = crypto?.randomUUID();
      });
      setPercentageValues(existingPercentValue);
    } catch (e) {
      setPercentageValues([]);
    }
  }, [actionValue]);

  const handlePercentageChange = (feId: string, percentage: string) => {
    const newPercentage = Number(percentage);
    if (isNaN(newPercentage) || newPercentage < 0 || newPercentage > 100) {
      //TODO: Add error notifications?
      return;
    }
    //get the total percentages plus the new percentage number. They should not be above 100
    const total = percentageValues.reduce((sum, item) =>
      item.feId === feId ? sum + newPercentage : sum + item.percentage
      , 0);
    if (total > 100) {
      //TODO: Add any messaging that the total should not be above 100 ?
      return;
    }

    const updatedList = percentageValues?.map(item =>
      item.feId === feId
        ? { ...item, percentage: newPercentage }
        : item
    ) || [];

    setPercentageValues(updatedList);
    onChange(JSON.stringify(updatedList));
  };

  const handleValueChange = (feId: string, value: string) => {
    const updatedList = percentageValues?.map(item =>
      item.feId === feId
        ? { ...item, value: value }
        : item
    ) || [];

    setPercentageValues(updatedList);
    onChange(JSON.stringify(updatedList));
  };

  const addPercentageValue = () => {
    setPercentageValues([...percentageValues, { feId: crypto.randomUUID(), percentage: 0, value: '' }]);
  };

  const handleDeleteRow = (feId: string) => {
    const updatedList = percentageValues.filter(item => item.feId !== feId);
    setPercentageValues(updatedList);
    onChange(JSON.stringify(updatedList));
  };

  return (
    <div>
      {percentageValues && percentageValues.map((field, index) => (
        <div key={index} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
          <Input
            type="number"
            min={0}
            max={100}
            maxLength={3}
            placeholder="0"
            value={field.percentage}
            onChange={(e) => handlePercentageChange(field.feId, e.target.value)}
            style={{ width: 60, textAlign: 'right', marginRight: 4 }}
          />
          <span style={{ color: 'var(--text-secondary)', fontSize: 12 }}>%</span>
          <Input
            placeholder="Value"
            value={field.value}
            onChange={(e) => handleValueChange(field.feId, e.target.value)}
            style={{ flex: 1 }}
          />
          <Tooltip title="This will delete the current row">
            <button
              type="button"
              onClick={() => handleDeleteRow(field.feId)}
              style={{
                background: 'none',
                border: 'none',
                color: 'var(--text-secondary)',
                cursor: 'pointer',
                fontSize: 16,
                marginLeft: 0,
                padding: 0
              }}
              aria-label="Delete row"
            >
              ×
            </button>
          </Tooltip>
        </div>
      ))}
      <Button
        type="dashed"
        icon={<PlusOutlined />}
        onClick={addPercentageValue}
        style={{ marginBottom: 16 }}
      >
        Add Row
      </Button>
    </div>
  );
};

export default AbTestingRandomChanceOutcome;
